import React, { useMemo, useState,useEffect } from 'react'
import {
  Card,
  Row,
  Col,
  Table,
  Select,
  DatePicker,
  Button,
  Statistic,
  Empty,
  Spin,
  Input,
} from 'antd'
import {
  ShoppingCartOutlined,
  ReloadOutlined,
  SearchOutlined,
 
  
} from '@ant-design/icons'
import { GiWineGlass, GiBeerStein, GiWineBottle } from "react-icons/gi";
import BillService from '../../../../services/Billservice'
import { notify } from '../../../../components/Customs/NotifyProvider'
import { canViewModule, canCreateModule, canUpdateModule, canDeleteModule } from '../../../../utils/permissionUtils'

const { RangePicker } = DatePicker
//color
  const iconStyle = { color: '#7c3aed', fontSize: '22px' }

const DrinkItemReport = () => {
  const MODULE_KEY = 'drink_item_report'
  const canView = canViewModule(MODULE_KEY)
  const canCreate = canCreateModule(MODULE_KEY)
  const canUpdate = canUpdateModule(MODULE_KEY)
  const canDelete = canDeleteModule(MODULE_KEY)
  const isViewOnly = canView && !canCreate && !canUpdate && !canDelete
  const [loading, setLoading] = useState(false)
  const [rowsRaw, setRowsRaw] = useState([])
  const [dateFilter, setDateFilter] = useState('today')
  const [range, setRange] = useState(null)
  const [searchText, setSearchText] = useState('')

  const buildFilters = () => {
    if (isViewOnly) return { date: 'today' }
    const filters = {}

    if (dateFilter === 'custom' && range && range.length === 2) {
      filters.from = range[0].startOf('day').format('YYYY-MM-DD HH:mm:ss')
      filters.to = range[1].endOf('day').format('YYYY-MM-DD HH:mm:ss')
    } else if (dateFilter === 'today') {
      filters.date = 'today'
    } else if (dateFilter === 'yesterday') {
      filters.date = 'yesterday'
    }

    return filters
  }

 const fetchData = async () => {
  if (!canView) return
  setLoading(true)
  try {
    const filters = buildFilters()

    const rows = await BillService.getDrinkItemReport(filters)
    console.log(" RAW API RESPONSE:", rows)

    setRowsRaw(Array.isArray(rows) ? rows : [])
  } catch (err) {
    notify.error(`Failed to load drink report: ${err.message}`)
    setRowsRaw([])
  } finally {
    setLoading(false)
  }
}

//auto today data 
useEffect(() => {
  fetchData()
}, [])


  //normalize
 const normalizeDrinkRow = (row) => {
  console.log(" RAW ROW details:", row.details);

  let details = {};

  try {
    details =
      typeof row.details === "string"
        ? JSON.parse(row.details)
        : row.details || {};
  } catch {
    details = {};
  }

  return {
    ...row,

    details,   // KEEP ORIGINAL STRUCTURE

    bottle_size: safeNumber(row.bottle_size),
    bottle_qty: safeNumber(row.bottle_qty),
    total_bottles: safeNumber(row.total_bottles),
    peg_qty: safeNumber(row.peg_qty),
  };
};







  //safenumber
  const safeNumber = (val) => {
  if (val === null || val === undefined) return 0;
  return Number(String(val).replace(/[^0-9.]/g, "")) || 0;
};

  // to collect peg details
  const parsePegs = (row) => {
  const details = row.details || {}

  const pegs = Array.isArray(details.pegs) ? details.pegs : []
  const pegQtys = details.peg_qtys || {}

  return pegs
    .map((peg) => {
      const count = Number(pegQtys?.[peg.id] || 0)

      return {
        id: peg.id,
        ml: Number(peg.qty || 0),
        price: Number(peg.price || 0),
        count,
        totalML: Number(peg.qty || 0) * count,
        totalPrice: count * Number(peg.price || 0),
      }
    })
    .filter((p) => p.count > 0)
}





const calculateDrink = (pegs = [], bottleSize = 0, totalBottles = 0, soldBottleQty = 0) => {
  const pegML = (pegs || []).reduce((sum, peg) => {
  const ml = Number(peg?.ml || 0)
  const count = Number(peg?.count || 0)

  return sum + (ml * count)
}, 0)

  const pegRevenue = (pegs || []).reduce((sum, peg) => {
  return sum + Number(peg?.totalPrice || 0)
}, 0)

  const bottleML = soldBottleQty * bottleSize
  const totalSoldML = pegML + bottleML

  const stockML = bottleSize * totalBottles


  //text half
   const bottleRatio = bottleSize ? totalSoldML / bottleSize : 0

const getBottleText = (ratio, soldML) => {
  const full = Math.floor(ratio)
  const rem = ratio - full

  let text = ""

  if (full > 0) {
    text += `${full} Bottle${full > 1 ? "s" : ""}`
  }

  if (rem >= 0.70) {
    text += `${text ? " + " : ""}Three Quarter`
  } else if (rem >= 0.45) {
    text += `${text ? " + " : ""}Half`
  } else if (rem >= 0.20) {
    text += `${text ? " + " : ""}Quarter`
  }

  if (!text) text = "0"

  // exact full bottle => no ml text
  if (rem === 0) {
    return text
  }

  return `${text} [${soldML}ml]`
}

const usedBottles = getBottleText(bottleRatio,totalSoldML)







  
  const remainingML = Math.max(stockML - totalSoldML, 0)



 //remaining total bottle
  const fullRemainingBottles = bottleSize
    ? Math.floor(remainingML / bottleSize)
    : 0

  const partialML = bottleSize
    ? remainingML % bottleSize
    : 0

  let remainingText = `${totalBottles}`

  if (partialML > 0) {
    let partName = ""

    const ratio = partialML / bottleSize

    if (ratio >= 0.70) {
      partName = "Three Quarter"
    } else if (ratio >= 0.45) {
      partName = "Half"
    } else if (ratio >= 0.20) {
      partName = "Quarter"
    }

    remainingText += ` + ${partialML}ml`

    if (partName) {
      remainingText += ` [${partName} Bottle]`
    }
  }


  return {
    totalSoldML,
    pegML,
    pegRevenue,
    usedBottles,
    remainingML,
    remainingBottles: remainingText,
  }
}

  

 

  const handleClear = () => {
    if (!canUpdate && !canDelete) {
      notify.error('Permission Denied', 'No permission to clear drink report filters')
      return
    }
    setDateFilter('today')
    setRange(null)
    setSearchText('')
    setRowsRaw([])
    
  }

  const rows = useMemo(() => {
  const search = searchText.trim().toLowerCase()

  return (rowsRaw || [])
    .map((row, index) => {
      const cleanRow = normalizeDrinkRow(row)

      console.log("CLEAN ROW:", JSON.stringify(cleanRow))

      // ✅ FIX 1: normalize pegs properly
      const pegs = cleanRow.pegs || []

      // ✅ FIX 2: safe bottle size (fallback from details)
      const bottleSize = Number(
        cleanRow.bottle_size ??
        cleanRow.details?.price_bottle ??
        0
      )

      // ✅ FIX 3: safe bottle qty (sold bottles)
      const bottleQty = Number(
        cleanRow.bottle_qty ??
        cleanRow.details?.bottle_qty ??
        0
      )

      // ✅ FIX 4: total bottles in stock
      const totalBottles = Number(cleanRow.total_bottles || 0)

      // ✅ FIX 5: correct calculation
      const calc = calculateDrink(
        pegs,
        bottleSize,
        totalBottles,
        bottleQty
      )

      return {
        ...cleanRow,

        key: `${cleanRow.item_name}-${index}`,

        // raw normalized values
        pegs,
        bottle_size: bottleSize,
        bottle_qty: bottleQty,
        total_bottles: totalBottles,

        // calculated values
        totalSoldML: calc.totalSoldML,
        pegML: calc.pegML,
        pegRevenue: calc.pegRevenue,
        usedBottles: calc.usedBottles,
        remainingML: calc.remainingML,
        remainingBottles: calc.remainingBottles,
      }
    })
    .filter((row) => {
      if (!search) return true

      return row.item_name?.toLowerCase().includes(search)
    })
}, [rowsRaw, searchText])

const summary = useMemo(() => {
  return {
    totalItems: rows.length,
    totalPegQty: rows.reduce((sum, r) => sum + (r.peg_qty || 0), 0),
    totalBottleQty: rows.reduce((sum, r) => sum + (r.bottle_qty || 0), 0),
    totalAmount: rows.reduce((sum, r) => sum + (r.total_amount || 0), 0),
  }
}, [rows])

  const columns = [
    {
      title: 'Drink Name',
      dataIndex: 'item_name',
      key: 'item_name',
      render: (value) => (
        <div style={{ fontWeight: 700, color: '#0f172a' }}>
          {value || '-'}
        </div>
      ),
    },
    {
      title: 'Peg Qty',
      dataIndex: 'peg_qty',
      key: 'peg_qty',
      align: 'center',
      render: (v) => v || 0,
    },
    {
      title: 'Bottle Qty',
      dataIndex: 'bottle_qty',
      key: 'bottle_qty',
      align: 'center',
      render: (v) => v || 0,
    },
    {
      title: 'Total Revenue',
      dataIndex: 'total_amount',
      key: 'total_amount',
      align: 'right',
      render: (v) => (
        <strong style={{ color: '#0f172a' }}>
          ₹{Number(v || 0).toFixed(2)}
        </strong>
      ),
    },


  ]



  const expandedRowRender = (record) => {
  return !canView ? (
    <Card>
      <Empty description="No permission to view drinks report" />
    </Card>
  ) : (
    <div>

      {/* 🔥 Summary Table */}
      <Table
        columns={[
          {
            title: 'Sold ML',
            dataIndex: 'totalSoldML',
            render: (v) => `${v || 0} ml`,
          },
          {
            title: 'Sold Bottles',
            dataIndex: 'usedBottles',
          },
          {
            title: 'Bottle Volume',
            dataIndex: 'bottle_size',
            render: (v) => `${v || 0} ml`,
          },
          {
            title: 'Stock Bottles',
            dataIndex: 'total_bottles',
          },
          
          {
            title: 'Remaining ML',
            dataIndex: 'remainingML',
            render: (v) => `${Number(v || 0)} ml`,
          },
          {
            title: 'Remaining Total Bottles',
            dataIndex: 'remainingBottles',
          },
          {
            title: 'Status',
            render: () =>
              record.error ? (
                <span style={{ color: 'red' }}>{record.error}</span>
              ) : (
                <span style={{ color: 'green' }}>Active</span>
              ),
          },
        ]}
        dataSource={[record]}   //  IMPORTANT (single row)
        pagination={false}
        rowKey="key"
      />

      {/*  Peg Breakdown Table */}
      <Table
        style={{ marginTop: 12 }}
        columns={[
          { title: 'Peg ML', dataIndex: 'ml' },
          { title: 'Count', dataIndex: 'count' },
          {
            title: 'Total ML',
            render: (row) => {
            const ml = Number(row.ml) || 0
            const count = Number(row.count) || 0
            return `${ml * count} ml`
          },
          },
        ]}
        dataSource={
          record.pegs.length
        ? record.pegs
      :[{ml:"Total pegs", count :record.peg_qty}]}
        pagination={false}
        rowKey={(row, i) => i}
      />

    </div>
  );
};
  return (
    <div className="table-report-page">
      <div className="table-report-hero">
        <div className="table-report-hero-left">
          <div className="table-report-hero-icon">
            <ShoppingCartOutlined />
          </div>
          <div>
            <h2 className="table-report-hero-title">Drinks Report</h2>
            <p className="table-report-hero-subtitle">
              Peg & bottle sales summary for drinks
            </p>
          </div>
        </div>
      </div>

      <Card className="table-report-card">
        <Row gutter={[12, 12]} className="table-report-filters">
          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              value={dateFilter}
              onChange={setDateFilter}
              disabled={isViewOnly}
              options={[
                { label: 'Today', value: 'today' },
                { label: 'Yesterday', value: 'yesterday' },
                { label: 'All', value: 'all' },
                { label: 'Custom Range', value: 'custom' },
              ]}
            />
          </Col>

          {dateFilter === 'custom' && !isViewOnly && (
            <Col xs={24} sm={12} md={10} lg={7}>
              <RangePicker
                style={{ width: '100%' }}
                value={range}
                onChange={(vals) => setRange(vals)}
              />
            </Col>
          )}

          <Col xs={24} sm={12} md={6} lg={4}>
            <Button
              type="primary"
              block
              icon={<ReloadOutlined />}
               className="table-report-load-btn"
              onClick={fetchData}
              loading={loading}
              disabled={!canView && !canCreate}
            >
              Load
            </Button>
          </Col>

          <Col xs={24} sm={12} md={6} lg={4}>
            <Button block 
            className="table-report-clear-btn"
            onClick={handleClear}
            disabled={!canUpdate && !canDelete}>
              Clear
            </Button>
          </Col>
        </Row>

        <div className="table-report-toolbar">
          <Input
            allowClear
            placeholder="Search drink..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <Row gutter={[16, 16]} className="table-report-stats">
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic title="Drinks" value={summary.totalItems}
                prefix={<GiBeerStein style={iconStyle} />}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic title="Peg Qty" value={summary.totalPegQty}
                prefix={<GiWineGlass style={iconStyle} />}
               />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic title="Bottle Qty" value={summary.totalBottleQty}
               prefix={<GiWineBottle style={iconStyle}/>}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Total Revenue"
                value={summary.totalAmount}
                precision={2}
                formatter={(v) => `₹${Number(v || 0).toFixed(2)}`}
              />
            </Card>
          </Col>
        </Row>

        <Spin spinning={loading}>
          {!rows.length ? (
            <Empty description="No drink report data found" />
          ) : (
            <Table
              rowKey= "key"
              columns={columns}
              dataSource={rows}
              pagination={{ pageSize: 10 }}
              expandable={{ expandedRowRender }}
            />
          )}
        </Spin>
      </Card>
    </div>
  )
}

export default DrinkItemReport
